var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"text":"","type":"info"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.localize(_vm.value.title))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }